import { dashboardActionTypes } from '../actions/types';

const initialState = {
  summary: {
    data: null,
    status: 'idle',
    error: null,
  },
  charts: {
    data: null,
    status: 'idle',
    error: null,
    activeRequestKey: null,
  },
};

export function dashboard(state = initialState, action) {
  switch (action.type) {
    case dashboardActionTypes.SUMMARY_REQUEST:
      return {
        ...state,
        summary: {
          ...state.summary,
          status: 'loading',
          error: null,
        },
      };
    case dashboardActionTypes.SUMMARY_SUCCESS:
      return {
        ...state,
        summary: {
          data: action.summary,
          status: 'loaded',
          error: null,
        },
      };
    case dashboardActionTypes.SUMMARY_FAILURE:
      return {
        ...state,
        summary: {
          ...state.summary,
          status: 'failed',
          error: action.error,
        },
      };
    case dashboardActionTypes.CHARTS_REQUEST:
      return {
        ...state,
        charts: {
          ...state.charts,
          status: 'loading',
          error: null,
          activeRequestKey: action.requestKey,
        },
      };
    case dashboardActionTypes.CHARTS_SUCCESS:
      if (state.charts.activeRequestKey !== action.requestKey) return state;
      return {
        ...state,
        charts: {
          data: action.charts,
          status: 'loaded',
          error: null,
          activeRequestKey: action.requestKey,
        },
      };
    case dashboardActionTypes.CHARTS_FAILURE:
      if (state.charts.activeRequestKey !== action.requestKey) return state;
      return {
        ...state,
        charts: {
          ...state.charts,
          status: 'failed',
          error: action.error,
        },
      };
    default:
      return state;
  }
}
